/* tslint:disable */
/* eslint-disable */
/**
 * Cerebral Machines API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LeadCreate } from '../models';
// @ts-ignore
import type { LeadUpdate } from '../models';
// @ts-ignore
import type { ValidationErrorModel } from '../models';
/**
 * LeadApi - axios parameter creator
 */
export const LeadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new lead
         * @param {LeadCreate} leadCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadCreatePost: async (leadCreate: LeadCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadCreate' is not null or undefined
            assertParamExists('leadCreatePost', 'leadCreate', leadCreate)
            const localVarPath = `/api/leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a lead by ID
         * @param {string} leadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadDeleteLeadIdDelete: async (leadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadId' is not null or undefined
            assertParamExists('leadDeleteLeadIdDelete', 'leadId', leadId)
            const localVarPath = `/api/leads/{lead_id}`
                .replace(`{${"lead_id"}}`, encodeURIComponent(String(leadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a lead by ID
         * @param {string} leadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadGetLeadIdGet: async (leadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadId' is not null or undefined
            assertParamExists('leadGetLeadIdGet', 'leadId', leadId)
            const localVarPath = `/api/leads/{lead_id}`
                .replace(`{${"lead_id"}}`, encodeURIComponent(String(leadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all leads
         * @param {string | null} [search] 
         * @param {string | null} [leadMagnetId] 
         * @param {string | null} [email] 
         * @param {string | null} [country] 
         * @param {string | null} [emailDomain] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadListGet: async (search?: string | null, leadMagnetId?: string | null, email?: string | null, country?: string | null, emailDomain?: string | null, limit?: number | null, offset?: number | null, orderBy?: string | null, orderDir?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (leadMagnetId !== undefined) {
                localVarQueryParameter['lead_magnet_id'] = leadMagnetId;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (emailDomain !== undefined) {
                localVarQueryParameter['email_domain'] = emailDomain;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDir !== undefined) {
                localVarQueryParameter['order_dir'] = orderDir;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a lead by ID
         * @param {string} leadId 
         * @param {LeadUpdate} leadUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadUpdateLeadIdPut: async (leadId: string, leadUpdate: LeadUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadId' is not null or undefined
            assertParamExists('leadUpdateLeadIdPut', 'leadId', leadId)
            // verify required parameter 'leadUpdate' is not null or undefined
            assertParamExists('leadUpdateLeadIdPut', 'leadUpdate', leadUpdate)
            const localVarPath = `/api/leads/{lead_id}`
                .replace(`{${"lead_id"}}`, encodeURIComponent(String(leadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadApi - functional programming interface
 */
export const LeadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new lead
         * @param {LeadCreate} leadCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadCreatePost(leadCreate: LeadCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadCreatePost(leadCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadApi.leadCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a lead by ID
         * @param {string} leadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadDeleteLeadIdDelete(leadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadDeleteLeadIdDelete(leadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadApi.leadDeleteLeadIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a lead by ID
         * @param {string} leadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadGetLeadIdGet(leadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadGetLeadIdGet(leadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadApi.leadGetLeadIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all leads
         * @param {string | null} [search] 
         * @param {string | null} [leadMagnetId] 
         * @param {string | null} [email] 
         * @param {string | null} [country] 
         * @param {string | null} [emailDomain] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadListGet(search?: string | null, leadMagnetId?: string | null, email?: string | null, country?: string | null, emailDomain?: string | null, limit?: number | null, offset?: number | null, orderBy?: string | null, orderDir?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadListGet(search, leadMagnetId, email, country, emailDomain, limit, offset, orderBy, orderDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadApi.leadListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a lead by ID
         * @param {string} leadId 
         * @param {LeadUpdate} leadUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadUpdateLeadIdPut(leadId: string, leadUpdate: LeadUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadUpdateLeadIdPut(leadId, leadUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadApi.leadUpdateLeadIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeadApi - factory interface
 */
export const LeadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeadApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new lead
         * @param {LeadApiLeadCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadCreatePost(requestParameters: LeadApiLeadCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeadCreate> {
            return localVarFp.leadCreatePost(requestParameters.leadCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a lead by ID
         * @param {LeadApiLeadDeleteLeadIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadDeleteLeadIdDelete(requestParameters: LeadApiLeadDeleteLeadIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leadDeleteLeadIdDelete(requestParameters.leadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a lead by ID
         * @param {LeadApiLeadGetLeadIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadGetLeadIdGet(requestParameters: LeadApiLeadGetLeadIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leadGetLeadIdGet(requestParameters.leadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all leads
         * @param {LeadApiLeadListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadListGet(requestParameters: LeadApiLeadListGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leadListGet(requestParameters.search, requestParameters.leadMagnetId, requestParameters.email, requestParameters.country, requestParameters.emailDomain, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDir, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a lead by ID
         * @param {LeadApiLeadUpdateLeadIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadUpdateLeadIdPut(requestParameters: LeadApiLeadUpdateLeadIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leadUpdateLeadIdPut(requestParameters.leadId, requestParameters.leadUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for leadCreatePost operation in LeadApi.
 */
export interface LeadApiLeadCreatePostRequest {
    readonly leadCreate: LeadCreate
}

/**
 * Request parameters for leadDeleteLeadIdDelete operation in LeadApi.
 */
export interface LeadApiLeadDeleteLeadIdDeleteRequest {
    readonly leadId: string
}

/**
 * Request parameters for leadGetLeadIdGet operation in LeadApi.
 */
export interface LeadApiLeadGetLeadIdGetRequest {
    readonly leadId: string
}

/**
 * Request parameters for leadListGet operation in LeadApi.
 */
export interface LeadApiLeadListGetRequest {
    readonly search?: string | null

    readonly leadMagnetId?: string | null

    readonly email?: string | null

    readonly country?: string | null

    readonly emailDomain?: string | null

    readonly limit?: number | null

    readonly offset?: number | null

    readonly orderBy?: string | null

    readonly orderDir?: string | null
}

/**
 * Request parameters for leadUpdateLeadIdPut operation in LeadApi.
 */
export interface LeadApiLeadUpdateLeadIdPutRequest {
    readonly leadId: string

    readonly leadUpdate: LeadUpdate
}

/**
 * LeadApi - object-oriented interface
 */
export class LeadApi extends BaseAPI {
    /**
     * 
     * @summary Create a new lead
     * @param {LeadApiLeadCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadCreatePost(requestParameters: LeadApiLeadCreatePostRequest, options?: RawAxiosRequestConfig) {
        return LeadApiFp(this.configuration).leadCreatePost(requestParameters.leadCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a lead by ID
     * @param {LeadApiLeadDeleteLeadIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadDeleteLeadIdDelete(requestParameters: LeadApiLeadDeleteLeadIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return LeadApiFp(this.configuration).leadDeleteLeadIdDelete(requestParameters.leadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a lead by ID
     * @param {LeadApiLeadGetLeadIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadGetLeadIdGet(requestParameters: LeadApiLeadGetLeadIdGetRequest, options?: RawAxiosRequestConfig) {
        return LeadApiFp(this.configuration).leadGetLeadIdGet(requestParameters.leadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all leads
     * @param {LeadApiLeadListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadListGet(requestParameters: LeadApiLeadListGetRequest = {}, options?: RawAxiosRequestConfig) {
        return LeadApiFp(this.configuration).leadListGet(requestParameters.search, requestParameters.leadMagnetId, requestParameters.email, requestParameters.country, requestParameters.emailDomain, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDir, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a lead by ID
     * @param {LeadApiLeadUpdateLeadIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadUpdateLeadIdPut(requestParameters: LeadApiLeadUpdateLeadIdPutRequest, options?: RawAxiosRequestConfig) {
        return LeadApiFp(this.configuration).leadUpdateLeadIdPut(requestParameters.leadId, requestParameters.leadUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

